import { render, staticRenderFns } from "./CmsRichText.vue?vue&type=template&id=090cddc8&"
import script from "./CmsRichText.vue?vue&type=script&lang=js&"
export * from "./CmsRichText.vue?vue&type=script&lang=js&"
import style0 from "./CmsRichText.vue?vue&type=style&index=0&id=090cddc8&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports